import React, { useEffect } from 'react';
import { FormikProvider, useFormik } from 'formik';
import PropTypes from 'prop-types';

import { ButtonsPanel } from '../ButtonsPanel/ButtonsPanel';
import { StepFourFormFields } from './StepFourFormFields';
import { stepperInfo } from '../stepperInfo';

import styles from './index.module.css';
import TrackSectionStickiness from '../../../analytics/TrackSectionStickiness ';

export const StepFour = ({
  step,
  draft,
  handleSaveAndClose,
  handleSubmit,
  handlePreviousStep,
  costCenterField,
  showAdditionalSourceField,
  showDocumentReasonForRideField,
  setFormikValues,
  disabledValues,
  showSubInformation = true,
  quickSchedule = false,
  setStepValid
}) => {
  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: draft && draft.step4 ? draft.step4 : stepperInfo[3].values,
    validationSchema: stepperInfo[3].schema({
      costCenterField,
      showAdditionalSourceField,
      showDocumentReasonForRideField,
    }),
    onSubmit: handleSubmit,
  });

  const { values, isValid } = formik;
  // console.log('StepFour values:', draft);
  // const [isUberRide, setisUberRide] = React.useState(draft?.step2?.vehicleType === 'uberAmbulatoryRide');
  //   console.log('StepFour isUberRide:', isUberRide);

  const isRequiredField = costCenterField?.isRequired || showAdditionalSourceField?.isRequired || showDocumentReasonForRideField?.isRequired;
  useEffect(() => {
    if (setStepValid) {

      if (!costCenterField?.show && !showAdditionalSourceField?.show && !showDocumentReasonForRideField?.show) {
        setStepValid(true);
      } else {
        setStepValid(formik.isValid);
      }
    }
  }, [formik.isValid, setStepValid, costCenterField?.show, showAdditionalSourceField?.show, showDocumentReasonForRideField?.show]);
  useEffect(() => {
    setFormikValues && setFormikValues(values, isValid, 'step4');
    return;
  }, [values, isValid, setFormikValues]);
  return (
    <>
      <TrackSectionStickiness sectionName="Create Ride Step 4" />
      {showSubInformation && !quickSchedule && <h2 className={styles.headTitle}>Step 4: Additional Information</h2>}

      {showSubInformation && !quickSchedule && !isRequiredField && <h3 className={styles.additionalTitle}>Additional Information</h3>}


      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit} className={styles.form}>
          <StepFourFormFields
            {...formik}
            costCenterField={costCenterField}
            showAdditionalSourceField={showAdditionalSourceField}
            showDocumentReasonForRideField={showDocumentReasonForRideField}
            disabledValues={disabledValues}
          />
          {showSubInformation && (
            <ButtonsPanel
              disabled={!formik.isValid}
              step={step}
              handlePreviousStep={handlePreviousStep}
              handleSaveAndClose={handleSaveAndClose}
              handleSubmit={handleSubmit}
            />
          )}
        </form>
      </FormikProvider>

    </>
  );
};

StepFour.propTypes = {
  step: PropTypes.number,
  draft: PropTypes.object,
  handleSaveAndClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  handlePreviousStep: PropTypes.func,
};
